const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year', label: '연도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear(),
          afterFix: '년',
          labelHiddenResolution: "xl",
        }
      },
      {
        'component': 'search-month', label: '월', value: 'month', query: {'y_m': 'month'},
        options: {
          default: '',
          lastLabel: true,
          useAll: true,
        }
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["대상년월", "교육인원(대상/참석)", "교육일자", "작성일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = Number(search.year || new Date().getFullYear());
    let month = search.month;
    const startDate = new Date(`${year}-${month || '01'}-01`).format('yyyy-MM-dd');
    const endDate = month ? new Date(new Date(startDate).setMonth(new Date(startDate).getMonth() + 1)).format('yyyy-MM-dd') : `${year+1}-01-01`;
    conditions.push({key: 'created_at', operator: '>=', value: startDate})
    conditions.push({key: 'created_at', operator: '<', value: endDate})

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      { name: "대상년월", key: "header.year" },
      { name: "사업장명", key: "body.stdInfo.field_name" },
      { name: "팀(업체)명", key: "body.stdInfo.section" },
      { name: "교육구분", key: "body.진행교육리스트[%]" },
      { name: "교육인원(대상/참석)", key: "body.교육인원대상자수" },
      { name: "교육담당자", key: "body.교육결과_담당자.담당자" },
      { name: "작성자", key: "body.stdInfo.writer_name" },
      { name: "작성일", key: "created_at" },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0: { // 대상년월
          const year = postContent.header.year; // 대상년도
          const month = postContent.header.month; // 대상월
          return `${year}년${month}월`;
        }
        case 1: // 사업장명
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2: // 팀(업체)명
          return func.getContent(value).stdInfo.section; // 팀(업체)명
        case 3: // 교육구분
          return func.getContent(value).교육구분.filter((e) => e.check).map((e) => e.text).join(', ');
        case 4: // 교육인원(대상/참석)
          return `${func.getContent(value).교육인원대상자수} / ${func.getContent(value).교육인원참석자수}`; // 교육인원(대상/참석)
        case 5: // 교육담당자
          return func.getContent(value).교육결과_담당자.담당자
        case 6: // 작성자
          return func.getContent(value).stdInfo.writer_name // 작성자
        case 7: // 작성일
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
